export default "__VITE_PUBLIC_ASSET__71ba0350__"